import logo from '../assets/appLogo/host-blue-logo.png'

const configData = {
  logo,
  APP_NAME: 'RENEXT',
  country: 'in',
  continent: 'na',
  authorization: null,
  countryCode: '+91-',
  contactNumberLength: 10,
}
export default configData
